export const UserType = {
  AGENT: 'AGENT',
  CRAFTSMAN: 'CRAFTSMAN',
};
